/* ===== RNDR Shopify theme — front-end interactions ===== */
(function(){

  /* === Inject cosmetic chrome (bg layers + hex cursor) === */
  /* The topbar/nav/footer are rendered by Liquid, so we only inject things that
     are purely cosmetic and not crawlable. */
  document.body.insertAdjacentHTML('afterbegin', `
    <div class="bg-mesh">
      <svg viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="hex" width="60" height="52" patternUnits="userSpaceOnUse">
            <path d="M30 1 L58 16 L58 46 L30 61 L2 46 L2 16 Z" fill="none" stroke="rgba(255,255,255,.08)" stroke-width="0.6"/>
          </pattern>
          <radialGradient id="glow" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stop-color="#FF5B1F" stop-opacity=".18"/>
            <stop offset="60%" stop-color="#FF5B1F" stop-opacity="0"/>
          </radialGradient>
        </defs>
        <rect width="100%" height="100%" fill="url(#hex)"/>
        <rect width="100%" height="100%" fill="url(#glow)"/>
      </svg>
    </div>
    <div class="bg-grain"></div>
    <div class="bg-vignette"></div>
    <div class="c-dot">
      <svg viewBox="-10 -10 20 20" aria-hidden="true">
        <polygon points="8,0 4,6.93 -4,6.93 -8,0 -4,-6.93 4,-6.93" fill="currentColor"/>
      </svg>
    </div>
    <div class="c-ring">
      <svg viewBox="-20 -20 40 40" aria-hidden="true">
        <polygon points="17,0 8.5,14.72 -8.5,14.72 -17,0 -8.5,-14.72 8.5,-14.72" fill="none" stroke="currentColor" stroke-width="1.1"/>
      </svg>
    </div>
  `);

  /* === Clock === */
  const clock = document.getElementById('clock');
  if (clock) setInterval(() => {
    clock.textContent = new Date().toLocaleTimeString('en-GB',{hour12:false}) + ' IST';
  }, 1000);

  /* === Hex cursor (dot + lagging ring) === */
  const dot = document.querySelector('.c-dot');
  const ring = document.querySelector('.c-ring');
  let mx=0,my=0,rx=0,ry=0;
  addEventListener('mousemove', e => {
    mx=e.clientX; my=e.clientY;
    if (dot) dot.style.transform = `translate(${mx}px,${my}px) translate(-50%,-50%)`;
  });
  (function loop(){
    rx += (mx-rx)*.18; ry += (my-ry)*.18;
    if (ring) ring.style.transform = `translate(${rx}px,${ry}px) translate(-50%,-50%)`;
    requestAnimationFrame(loop);
  })();
  const hoverSel = 'a, button, .product, [data-cursor], summary, .swatch, .size, .chip, .thumb';
  document.addEventListener('mouseover', e => {
    if (e.target.closest && e.target.closest(hoverSel)) document.body.classList.add('is-cursor-hover');
  });
  document.addEventListener('mouseout', e => {
    if (e.target.closest && e.target.closest(hoverSel)) document.body.classList.remove('is-cursor-hover');
  });

  /* === Background parallax === */
  addEventListener('mousemove', e => {
    const x = (e.clientX/innerWidth-.5)*10;
    const y = (e.clientY/innerHeight-.5)*10;
    const sv = document.querySelector('.bg-mesh svg');
    if (sv) sv.style.transform = `translate(${x}px,${y}px)`;
  });

  /* === Scroll reveal === */
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => { if(en.isIntersecting){en.target.classList.add('in'); io.unobserve(en.target);} });
  }, {threshold:0, rootMargin:'0px 0px -10% 0px'});
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  /* === Product card tilt === */
  document.querySelectorAll('[data-tilt]').forEach(card => {
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX-r.left)/r.width - .5;
      const y = (e.clientY-r.top)/r.height - .5;
      card.style.transform = `perspective(1000px) rotateY(${x*4}deg) rotateX(${-y*4}deg) translateY(-4px)`;
    });
    card.addEventListener('mouseleave', () => card.style.transform = '');
  });

  /* === Mobile menu === */
  const burger = document.getElementById('burger');
  const burgerClose = document.getElementById('burgerClose');
  const overlay = document.getElementById('menuOverlay');
  const openMenu = () => { overlay?.classList.add('is-open'); document.body.style.overflow='hidden'; };
  const closeMenu = () => { overlay?.classList.remove('is-open'); document.body.style.overflow=''; };
  burger?.addEventListener('click', openMenu);
  burgerClose?.addEventListener('click', closeMenu);
  document.addEventListener('keydown', e => { if(e.key==='Escape') closeMenu(); });

  /* === PDP gallery (thumb switching) === */
  document.querySelectorAll('.thumb').forEach(t => {
    t.addEventListener('click', () => {
      const wrap = t.closest('.gallery');
      const id = t.dataset.view;
      wrap.querySelectorAll('.thumb').forEach(x => x.classList.toggle('is-on', x===t));
      wrap.querySelectorAll('.view').forEach(v => v.style.display = v.dataset.view===id ? '' : 'none');
      const meta = wrap.querySelector('.view-meta');
      if (meta) meta.textContent = 'VIEW · ' + id.toUpperCase();
    });
  });

  /* === PDP color swatches === */
  /* Filter gallery to images tied to the selected color (via image.variants in Liquid).
     Images with empty data-colors are treated as "general" and shown for any color. */
  function filterGalleryByColor(color){
    if (!color) return;
    const gallery = document.querySelector('.gallery');
    if (!gallery) return;
    const needle = ',' + color + ',';
    const views  = gallery.querySelectorAll('.main-view .view');
    const thumbs = gallery.querySelectorAll('.thumbs .thumb');
    const isMatch = el => {
      const c = el.dataset.colors || '';
      return c === '' || c.indexOf(needle) >= 0;
    };
    let firstShownView = null;
    views.forEach(v => {
      if (isMatch(v) && !firstShownView) { v.style.display = ''; firstShownView = v; }
      else { v.style.display = 'none'; }
    });
    let firstShownThumb = null;
    thumbs.forEach(t => {
      const match = isMatch(t);
      t.style.display = match ? '' : 'none';
      t.classList.remove('is-on');
      if (match && !firstShownThumb) firstShownThumb = t;
    });
    if (firstShownThumb) {
      firstShownThumb.classList.add('is-on');
      const meta = gallery.querySelector('.view-meta');
      if (meta) meta.textContent = 'VIEW · ' + (firstShownThumb.dataset.view || '').toUpperCase();
    }
  }

  document.querySelectorAll('.swatch').forEach(s => {
    s.addEventListener('click', () => {
      s.parentElement.querySelectorAll('.swatch').forEach(x => x.classList.remove('is-on'));
      s.classList.add('is-on');
      const label = s.closest('.details')?.querySelector('[data-color-label]');
      if (label) label.textContent = s.dataset.color || '';
      filterGalleryByColor(s.dataset.color);
      syncSelectedVariant(s.closest('form.product-form'));
    });
  });

  /* === PDP size picker === */
  document.querySelectorAll('.size:not(.is-out)').forEach(b => {
    b.addEventListener('click', () => {
      b.parentElement.querySelectorAll('.size').forEach(x => x.classList.remove('is-on'));
      b.classList.add('is-on');
      syncSelectedVariant(b.closest('form.product-form'));
    });
  });

  /* === Shop filter chips === */
  document.querySelectorAll('.chip').forEach(ch => {
    ch.addEventListener('click', () => {
      ch.parentElement.querySelectorAll('.chip').forEach(x => x.classList.remove('is-on'));
      ch.classList.add('is-on');
    });
  });

  /* === Variant resolution for Shopify product form === */
  /* Each .swatch/.size carries data-color / data-size matching a Shopify variant
     option. We compute the matching variant id and write it into the hidden
     input[name="id"] so the form submits the correct variant to /cart/add. */
  function syncSelectedVariant(form){
    if (!form) return;
    const variants = form.dataset.variants ? JSON.parse(form.dataset.variants) : null;
    if (!variants) return;
    const color = form.querySelector('.swatch.is-on')?.dataset?.color;
    const size  = form.querySelector('.size.is-on')?.dataset?.size;
    const match = variants.find(v =>
      (!color || v.option1 === color || v.option2 === color || v.option3 === color) &&
      (!size  || v.option1 === size  || v.option2 === size  || v.option3 === size)
    );
    const hidden = form.querySelector('input[name="id"]');
    if (match && hidden) hidden.value = match.id;
    const priceEl = form.querySelector('[data-variant-price]');
    if (match && priceEl) priceEl.textContent = formatMoney(match.price);
    const cta = form.querySelector('button[type=submit]');
    if (cta) cta.disabled = !match || !match.available;
    if (cta && match && !match.available) cta.textContent = 'Sold out';
  }
  function formatMoney(cents){
    const r = (cents/100).toFixed(0);
    return '₹ ' + r.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  // Wire on load: sync each form and filter gallery to the initial color
  document.querySelectorAll('form.product-form').forEach(form => {
    syncSelectedVariant(form);
    const initialColor = form.querySelector('.swatch.is-on')?.dataset?.color;
    if (initialColor) filterGalleryByColor(initialColor);
  });

  /* === Cart row qty controls (Shopify Ajax cart) === */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.qty button');
    if (!btn) return;
    const span = btn.parentElement.querySelector('[data-qty]');
    const row = btn.closest('[data-cart-line]');
    if (!span || !row) return;
    let q = parseInt(span.dataset.qty, 10) || 1;
    q = btn.dataset.act === '+' ? q+1 : Math.max(1, q-1);
    span.dataset.qty = q;
    span.textContent = q;
    updateCartLine(row.dataset.cartLine, q);
  });

  document.addEventListener('click', e => {
    const rm = e.target.closest('[data-remove]');
    if (!rm) return;
    const row = rm.closest('[data-cart-line]');
    if (row) updateCartLine(row.dataset.cartLine, 0).then(() => row.remove());
  });

  function updateCartLine(line, qty){
    // /cart/update.js with an explicit per-key update is reliable on this store;
    // /cart/change.js was clearing sibling lines when any one line was touched.
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ updates: { [line]: qty } })
    }).then(r => r.json()).then(cart => {
      // Shopify returns an error object (no item_count) on failure — bail out.
      if (typeof cart.item_count !== 'number') return cart;

      const count = document.querySelectorAll('[data-cart-count]');
      count.forEach(el => el.textContent = String(cart.item_count).padStart(2,'0'));
      const subtotal = document.querySelector('[data-subtotal]');
      const total = document.querySelector('[data-total]');
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
      if (total) total.textContent = formatMoney(cart.total_price);

      // "N pair(s) queued" and "N item(s)" headers rendered server-side at page load.
      document.querySelectorAll('[data-cart-pairs-text]').forEach(el => {
        el.textContent = cart.item_count + ' pair' + (cart.item_count === 1 ? '' : 's') + ' queued';
      });
      document.querySelectorAll('[data-cart-items-text]').forEach(el => {
        el.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
      });

      // If the cart just emptied, reload so Liquid renders the empty-cart state.
      if (cart.item_count === 0 && document.querySelector('.cart-grid')) {
        window.location.reload();
      }
      return cart;
    });
  }

})();
